import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'

import { hasProOrAboveAccess, userHasSiteCoverageAccess } from 'utils/access'
import { selectState } from 'utils/redux'

const useHasCoverageReportAccess = () => {
  const hasCoverageReportCutover = useSelector((state) =>
    pathOr(
      false,
      ['namespace', 'COVERAGE_REPORT'],
      selectState(state, 'cutovers')
    )
  )

  return (
    (hasProOrAboveAccess() || hasCoverageReportCutover) &&
    userHasSiteCoverageAccess()
  )
}

export default useHasCoverageReportAccess
